// add in the flag name of flags as strings.
// REQUIRED for any flags to work. Subscribe here for the app to listen to any of these flags and get values
// For example:
// ['feature_learn-2790_react-poc_01-2020']
export default [
  'feature-LEARN-11000-language-toggle',
  'feature_LEARN-16712_player-video-v3',
]
